import type { RootState } from '../../../index';

export const chatMessages = (state: RootState) => state.messages.messages;
export const unreadMessagesSelector = (state: RootState) => state.messages.hasUnreadMessages;

export const typingSelector = (state: RootState) => state.messages.typing;

export const replyToSupportSelector = (state: RootState) => state.messages.replyToSupport;
